'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _doCandleEqual = require('./doCandleEqual');

var _doCandleEqual2 = _interopRequireDefault(_doCandleEqual);

var _doArrayDifferJustOneEntry = require('./doArrayDifferJustOneEntry');

var _doArrayDifferJustOneEntry2 = _interopRequireDefault(_doArrayDifferJustOneEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (candles1, candles2) {
    return (0, _doArrayDifferJustOneEntry2.default)(candles1, candles2, _doCandleEqual2.default);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/doCandlesDifferJustOneEntry.js
// module id = 114
// module chunks = 0